<template>
  <div id="app">
    <div class="pc" v-if="!isMobile">
      <cover class="home-cover" />
      <router-view class="home-view"></router-view>
    </div>
    <div class="mobile" v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script type="ts">
import { defineComponent } from "@vue/composition-api";
import cover from "@/components/common/cover.vue";
import { deviceDetector } from "./utils/common";

export default defineComponent({
  name: "App",
  components: {
    cover,
  },
  data() {
    return {
      isMobile: deviceDetector(),
    };
  },
  computed: {
    isShowCover() {
      const isMobile = deviceDetector(); // 判断是否是移动端
      return !(isMobile);
    },
  },
});
</script>

<style lang="stylus" scoped>
.pc
  display flex

.home-cover
  flex 1

.home-view
  flex-shrink 0
  z-index 600
  background #ffffff
  width 960px
</style>
